import React from "react";

const Impressum = (props: any) => {
    return (
        <div className='impressumInfo'>
            <div className='row'>
                <h2 className='title'>Impressum</h2>
            </div>
            <div className='row'>
                <span className='col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12'>
                    <u>Vorsitzender des Arbeiterbetriebsrates:</u> Andreas Brich
                </span>
            </div>
            <div className='row'>
                <span className='col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12'>
                    <u>Vorsitzender des Angestelltenbetriebsrates:</u> Karl Lang
                </span>
            </div>
            <div className='row' style={{ marginTop: '5%' }}>
                <h2 className='title'>Adresse / Kontaktdaten</h2>
            </div>
            <div className='row'>
                <div className='col-4 col-sm-2'>
                    <u className=''>Straße:</u>
                </div>
                <div className='col-8 col-sm-2'>
                    <span >Hinterbergerstraße 2</span>
                </div>
                <div className='w-100'></div>
                <div className='col-4 col-sm-2'>
                    <u className=''>Postleitzahl:</u>
                </div>
                <div className='col-8 col-sm-2'>
                    <span >4400</span>
                </div>
                <div className='w-100'></div>
                <div className='col-4 col-sm-2'>
                    <u className=''>Ort:</u>
                </div>
                <div className='col-8 col-sm-2'>
                    <span >Steyr</span>
                </div>
                <div className='w-100'></div>
                <div className='col-4 col-sm-2'>
                    <u className=''>Telefonnr.:</u>
                </div>
                <div className='col-8 col-sm-2'>
                    <span >+43 7252 888 2153</span>
                </div>
                <div className='w-100'></div>
                <div className='col-4 col-sm-2'>
                    <u className=''>E-Mail:</u>
                </div>
                <div className='col-8 col-sm-2'>
                    <span> arbeiterbetriebsrat@list.bmw.com</span>
                </div>
                <div className='w-100' style={{marginTop:'3%'}}></div>
                <div className='col-4 col-sm-2'>
                    <u className=''>Servicezeiten Arbeiterbetriebsrat:</u>
                </div>
                <div className='col-8 col-sm-2 ta-sm-right' style={{ textAlign: 'left' }}>
                    <span> Mo-Do 13:00 - 16:00 Uhr</span>
                    <br />
                    <span> Fr. 13:00 – 15:00 Uhr</span>
                </div>
                <div className='w-100'></div>
                <div className='col-4 col-sm-2'>
                    <u className=''>Angestelltenbetriebsrat:</u>
                </div>
                <div className='col-8 col-sm-2 ta-sm-right' style={{ textAlign: 'left' }}>
                    <span> Mo-Fr 10:00 – 12:30 Uhr</span>
                </div>
            </div>
        </div>
    )
}

export default Impressum